import { useState } from "react";
import { createContext } from "react";

export const ReversePaymentContext = createContext({});

export const ReversePaymentProvider = ({ children }) => {
  const [openReverse, setOpenReverse] = useState(false);
  const [currentEvidenceIndex, setCurrentEvidenceIndex] = useState(-1);
  const [evidence, setEvidence] = useState(null);
  const [loadingCal, setLoadingCal] = useState(false);

  return (
    <ReversePaymentContext.Provider
      value={{
        loadingCal,
        setLoadingCal,
        openReverse,
        setOpenReverse,
        currentEvidenceIndex,
        setCurrentEvidenceIndex,
        evidence,
        setEvidence,
      }}
    >
      {children}
    </ReversePaymentContext.Provider>
  );
};
